/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type InvoiceList_storeLists$ref = any;
export type DeleteInvoiceInput = {|
  clientMutationId?: ?string,
  id: string,
|};
export type deleteInvoiceMutationVariables = {|
  input: DeleteInvoiceInput,
  storeId: string,
|};
export type deleteInvoiceMutationResponse = {|
  +deleteInvoice: ?{|
    +destroyedInvoiceId: string,
    +storeLists: {|
      +$fragmentRefs: InvoiceList_storeLists$ref
    |},
  |}
|};
export type deleteInvoiceMutation = {|
  variables: deleteInvoiceMutationVariables,
  response: deleteInvoiceMutationResponse,
|};
*/


/*
mutation deleteInvoiceMutation(
  $input: DeleteInvoiceInput!
  $storeId: ID!
) {
  deleteInvoice(input: $input) {
    destroyedInvoiceId
    storeLists {
      ...InvoiceList_storeLists_1dSt7N
      id
    }
  }
}

fragment InvoiceList_storeLists_1dSt7N on StoreLists {
  id
  invoices(storeId: $storeId) {
    id
    startDate
    endDate
    amountDue
    state
    invoiceNumber
    invoicePdfUrl
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input",
    "type": "DeleteInvoiceInput!"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "storeId",
    "type": "ID!"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "destroyedInvoiceId",
  "storageKey": null
},
v3 = [
  {
    "kind": "Variable",
    "name": "storeId",
    "variableName": "storeId"
  }
],
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "deleteInvoiceMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "DeleteInvoicePayload",
        "kind": "LinkedField",
        "name": "deleteInvoice",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "StoreLists",
            "kind": "LinkedField",
            "name": "storeLists",
            "plural": false,
            "selections": [
              {
                "args": (v3/*: any*/),
                "kind": "FragmentSpread",
                "name": "InvoiceList_storeLists"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "RootMutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "deleteInvoiceMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "DeleteInvoicePayload",
        "kind": "LinkedField",
        "name": "deleteInvoice",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "StoreLists",
            "kind": "LinkedField",
            "name": "storeLists",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              {
                "alias": null,
                "args": (v3/*: any*/),
                "concreteType": "Invoice",
                "kind": "LinkedField",
                "name": "invoices",
                "plural": true,
                "selections": [
                  (v4/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "startDate",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "endDate",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "amountDue",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "state",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "invoiceNumber",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "invoicePdfUrl",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "deleteInvoiceMutation",
    "operationKind": "mutation",
    "text": "mutation deleteInvoiceMutation(\n  $input: DeleteInvoiceInput!\n  $storeId: ID!\n) {\n  deleteInvoice(input: $input) {\n    destroyedInvoiceId\n    storeLists {\n      ...InvoiceList_storeLists_1dSt7N\n      id\n    }\n  }\n}\n\nfragment InvoiceList_storeLists_1dSt7N on StoreLists {\n  id\n  invoices(storeId: $storeId) {\n    id\n    startDate\n    endDate\n    amountDue\n    state\n    invoiceNumber\n    invoicePdfUrl\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'fb65d34c7ee15b825424e1accdd71ca4';

module.exports = node;
